import * as requestServices from "../request"

export const cfRequest = {
    getAllCustomFields(url, firmId, oAuthToken) {
        let param = {
            firmId: firmId,
            oAuthToken:oAuthToken
        }
        return requestServices.get(url, param).then((data) => (data)).then((res) => {
            return res;
        });
    },

    saveCustomFields(url, data) {
        return requestServices.post(url, data).then((data) => (data)).then((res) => {
            return res;
        }).catch((response) => {
            console.log('response', response);
            return response;
        }); 
    }
}